import AuthGuard from 'app/main/AuthGuard';
import ServerRestartConfig from './ServerRestartConfig';

const ServerRestartConfigRoute = {
  settings: {},
  routes: [
    {
      path: '/server-restart-config',
      component: () => AuthGuard(<ServerRestartConfig />),
    },
  ],
};

export default ServerRestartConfigRoute;
